import React from "react";
import { Badge, IconButton, makeStyles } from "@material-ui/core";
import NotificationsIcon from "@material-ui/icons/Notifications";
import NotificationsNoneIcon from "@material-ui/icons/NotificationsNone";

const useStyles = makeStyles({
  badge: {
    "& .MuiBadge-anchorOriginTopRightRectangle": {
      top: 5,
      right: 6,
    },
  },
});

interface PublicProps {
  withRedDot: boolean;
  iconButtonProps?: object;
}

const Campana: React.FC<PublicProps> = ({ withRedDot, iconButtonProps }) => {
  const classes = useStyles();

  let icon = <NotificationsNoneIcon />;

  if (withRedDot) {
    icon = (
      <Badge className={classes.badge} color="error" variant="dot">
        <NotificationsIcon />
      </Badge>
    );
  }

  return <IconButton {...iconButtonProps}>{icon}</IconButton>;
};

export default Campana as React.ComponentType<PublicProps>;
